import { useContext } from 'preact/compat';

import { PortalsManagerContext } from './context';

export function usePortalsManager() {
  const portalsManager = useContext(PortalsManagerContext);

  if (!portalsManager) {
    throw new Error('Webtex Reviews: No portals manager was provided.');
  }

  return portalsManager;
}
